import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const articlesApi = createApi({
  reducerPath: 'articlesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getArticles: builder.query({
      query: () => ({
        url: urls.articles,
      }),
    }),
    getArticle: builder.query({
      query: ({ id, isEdit = true }) => ({
        url: id ? urls.articlesDetail(id, isEdit) : null,
      }),
    }),
    deleteArticle: builder.mutation({
      query(id) {
        return {
          url: `${urls.articles}/${id}`,
          method: 'DELETE',
        };
      },
    }),
    saveArticle: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.articlesDetail(req.id, true),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.articles,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
  }),
});

export const {
  useGetArticlesQuery,
  useGetArticleQuery,
  useDeleteArticleMutation,
  useSaveArticleMutation,
} = articlesApi;
